import Scene = Phaser.Scene;
import Graphics = Phaser.GameObjects.Graphics;
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {SquareButton} from "@/scenes.ui/square-button";
import {Keys} from "@/constants/key";
import CU from "@/utils/c-u";
import {Tr} from "@/i18n/i18n";

export default class BlackoutText extends Phaser.GameObjects.Container {

    private static blackoutImage: Graphics;
    private canvas: HTMLCanvasElement;
    private static counter: number = 0;
    private static showing: boolean = false;

    constructor(scene: Scene, canvas: HTMLCanvasElement) {
        super(scene);

        this.scene = scene;
        this.canvas = canvas;

        this.setDepth(10001);
    }

    public show(texts: string[], callback: () => unknown) {
        if (BlackoutText.showing) {
            return;
        }
        BlackoutText.showing = true;
        BlackoutText.counter = 0;
        if (BlackoutText.blackoutImage) {
            this.scene.tweens.killTweensOf(BlackoutText.blackoutImage);
        }

        let self = this;

        BlackoutText.blackoutImage = self.scene!.add.graphics();
        BlackoutText.blackoutImage.setDepth(10000).setAlpha(0);

        let color = Phaser.Display.Color.HexStringToColor('#000000').color;

        BlackoutText.blackoutImage.fillRect(0, 0, self.canvas.width, self.canvas.height);
        BlackoutText.blackoutImage.fillStyle(color);

        self.scene.tweens.add({
            targets: BlackoutText.blackoutImage,
            delay: 1000,
            alpha: 1,
            duration: 300,
            onComplete() {
                BlackoutText.blackoutImage.setAlpha(1);

                self.doShowText(texts, 30, callback);
            }
        });

        this.scene.add.existing(this);
    }

    private doShowText(texts: string[], bottomY: number, callback: () => unknown) {
        let self = this;
        let text1 = TextUtils.addTextAdvanced(self.scene, texts[BlackoutText.counter], self.canvas.width / 2 / CU.S, bottomY,
            '#ffffff', 18, 'italic', 550, 'center', 2, Fonts.ARIAL_MT).setOrigin(0.5, 0);
        text1.setAlpha(0);
        text1.setDepth(BlackoutText.blackoutImage.depth + 1);
        self.add(text1);

        self.scene.tweens.add({
            targets: text1,
            delay: 1000,
            alpha: 1,
            duration: 1000,
            onComplete() {
                ++BlackoutText.counter;
                if (BlackoutText.counter < texts.length) {
                    self.doShowText(texts, text1.getBottomCenter().y! / CU.S + 25, callback);
                } else {
                    let okButton = new SquareButton(self.scene, self.canvas.width / 2 / CU.S, text1.getBottomCenter().y! / CU.S + 100, 0,
                        Keys.UI_ART_GREEN_BUTTON, Keys.ATLAS_PROFILE, Keys.UI_GOLDEN_CHECK, Tr('lgo'), false);
                    okButton.setAlpha(0);
                    self.add(okButton);
                    okButton.setCallback(() => {
                        if (callback != null) {
                            BlackoutText.showing = false;
                            callback();
                        }
                    });
                    self.scene.tweens.add({
                        targets: okButton,
                        alpha: 1,
                        duration: 1000,
                    });
                }
            }
        });
    }
}
